module.exports = __webpack_public_path__ + "static/media/subscription-icons.d6ebd876.png";